import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Page from "../../Components/Page";
import {BulkLoadArchiveButton, bulkLoadOptionsEnum} from "../BulkLoadArchiveButton";
import {RerunCleanseButton} from "../RerunCleanseButton";
import {CleanseSalesToParquetButton} from "../CleanseSalesToParquetButton";
import {FillAllForRetailer} from "../FillAllForRetailer";
import Checkbox from "../../Components/Checkbox";
import {makeApiCall, makeApiCallPost} from "../../../Api/makeApiCall";
import ButtonLoader from "../../../utils/components/ButtonLoader";
import {createDagRunConf} from "../../../Api/dagRunConf";
import {getUserEmail} from "../../../auth/accessTokenValidator";
import SelectDropdown from "../../Components/Dropdowns/SelectDropdown";

export const ActionsTab = ({active, retailChain, retailerId}) => {

    const [fillAllDates, setFillAllDates] = useState(false);
    const [fillIncludePlu, setFillIncludePlu] = useState(true);
    const [skipFillRetailerIds, setSkipFillRetailerIds] = useState([]);
    const [jsonToDeleteDate, setJsonToDeleteDate] = useState(null);
    const [storeIdsOptions, setStoreIdsOptions] = useState([]);
    const [selectedStore, setSelectedStore] = useState(undefined);
    const [isStoresLoading, setIsStoresLoading] = useState(true)

    const toggleFillAllDates = () => {
        setFillAllDates(!fillAllDates)
    }

    const toggleFillIncludePlu = () => {
        setFillIncludePlu(!fillIncludePlu)
    }

    useEffect(() => {
        Promise.all([
            makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/skipFillRetailers/`),
            makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/stores/`)
        ]).then(([data, storesResults]) => {
            const skipFillRetailerIds = data['data'].map(retailer => retailer.retailerId);
            setSkipFillRetailerIds(skipFillRetailerIds)

            const filteredStores = storesResults.data
                .filter(store => store.retailerId === retailerId)
                .map(store => {
                        return {
                            storeId: store.storeId,
                            storeName: store.storeName
                        }
                    }
                )

            setStoreIdsOptions(filteredStores.map(store => ({
                label: `${store.storeId} - ${store.storeName}`,
                value: store.storeId
            })))
            setIsStoresLoading(false)

        })
    }, []);

    return (<>
        <div id={'actions-tab'}>
            <Page name={'Reload'} displayHelmetHeader={false}>
                <BulkLoadArchiveButton retailerId={retailerId} fileType={bulkLoadOptionsEnum.sales}/>
                <BulkLoadArchiveButton retailerId={retailerId} fileType={bulkLoadOptionsEnum.items}/>
            </Page>
            <Page name={'Cleanse'} displayHelmetHeader={false}>
                <RerunCleanseButton retailerId={retailerId}/>
                <CleanseSalesToParquetButton retailerId={retailerId}/>
            </Page>
            <Page name={'Fill'} displayHelmetHeader={false}>
                <div className={'horizontal-control-block-element-left-actions-tab'}>
                    <Checkbox checked={fillAllDates}
                              labelText='Fill All Dates'
                              onChange={toggleFillAllDates}
                    />
                    <Checkbox checked={fillIncludePlu}
                              labelText='Include Plu'
                              onChange={toggleFillIncludePlu}
                    />
                    <FillAllForRetailer retailerId={retailerId}
                                        active={active}
                                        skipFillRetailerIds={skipFillRetailerIds}
                                        fillAllDates={fillAllDates}
                                        fillIncludePlu={fillIncludePlu}
                    />
                    <ButtonLoader
                        buttonClassName={'button alert'}
                        buttonTitle={'Delete All Fill Data'}
                        buttonHasModal
                        modalHeader={'Delete All Fill Data'}
                        userAcknowledgedCheck
                        modalText={`Are you sure you want to delete all fill data for ${retailChain}?`}
                        axiosFunction={makeApiCallPost}
                        url={`${process.env.REACT_APP_EDP_API_BASE_URL}/dagTrigger`}
                        postBody={{
                            dagName: 'retailer_delete_specified_non_archive_data',
                            data: createDagRunConf({
                                retailer_ids: [retailerId],
                                assets_to_delete: ['FILL_TO_DELETE']
                            })
                        }}
                        toastTextFailure={`Delete All Fill Data for ${retailChain} has failed to kicked off.`}
                        toastTextSuccess={`Delete All Fill Data for ${retailChain} has successfully kicked off.`}
                    />
                </div>
            </Page>
            <Page name={'Data Clean up'} displayHelmetHeader={false}>
                <div className={'horizontal-control-block-element-left short-input'}>
                    <input
                        data-testid={'delete-json-calendar'}
                        className={'input-group-field delete-json-calendar'}
                        type="date"
                        onChange={(event) => setJsonToDeleteDate(event.target.value)}
                    />
                    <div className={'select-store-dropdown'}>
                        <SelectDropdown
                            id={`stores_dropdown`}
                            dataTestId={"stores_dropdown"}
                            options={storeIdsOptions}
                            onChange={(options) => {
                                if (options !== null) {
                                    setSelectedStore(options.value);
                                } else {
                                    setSelectedStore(undefined);
                                }
                            }}
                            isDisabled={false}
                            isClearable={true}
                        />
                    </div>
                    <ButtonLoader
                        buttonClassName={'button alert'}
                        buttonTitle={`Delete All json Data`}
                        buttonHasModal
                        modalHeader={`Delete All json Data`}
                        userAcknowledgedCheck
                        disabled={!jsonToDeleteDate || isStoresLoading}
                        modalText={`Are you sure you want to delete All json Data for retailer ${retailerId} on ${jsonToDeleteDate} ${selectedStore ? `for store ${selectedStore}` : 'for all stores'}.\n
                                                        You will need to re-ingest the original file with corrected date`}
                        axiosFunction={makeApiCallPost}
                        url={`${process.env.REACT_APP_EDP_API_BASE_URL}/dagTrigger`}
                        postBody={{
                            dagName: 'delete_retailer_json_by_date',
                            data: createDagRunConf({
                                retailer_id: retailerId,
                                week_end_dates: [jsonToDeleteDate],
                                triggered_by: getUserEmail(),
                                store_id: selectedStore,
                            })
                        }}
                        toastTextFailure={`Delete All json Data for retailer ${retailerId} on ${jsonToDeleteDate} has failed to kicked off.`}
                        toastTextSuccess={`Delete All json Data for retailer ${retailerId} on ${jsonToDeleteDate} has successfully kicked off.`}
                    />
                </div>
            </Page>
            <Page name={'Other'} displayHelmetHeader={false}>
                <ButtonLoader
                    buttonClassName={'button alert'}
                    buttonTitle={'Delete All Processed Data'}
                    buttonHasModal
                    modalHeader={'Delete All Processed Data'}
                    userAcknowledgedCheck
                    modalText={`Are you sure you want to delete all processed data for ${retailChain}?`}
                    axiosFunction={makeApiCallPost}
                    url={`${process.env.REACT_APP_EDP_API_BASE_URL}/dagTrigger`}
                    postBody={{
                        dagName: 'retailer_delete_all_non_archive_data',
                        data: createDagRunConf({retailer_ids: [retailerId]})
                    }}
                    toastTextFailure={`Delete All Processed Data for ${retailChain} has failed to kicked off.`}
                    toastTextSuccess={`Delete All Processed Data for ${retailChain} has successfully kicked off.`}
                />
                <ButtonLoader
                    buttonClassName={'button alert'}
                    buttonTitle={'Delete Configurations'}
                    buttonHasModal
                    modalHeader={'Delete Configurations'}
                    userAcknowledgedCheck
                    modalText={`Are you sure you want to delete configurations AlwaysFill, DoNotFill, MeasuresStart, and MeasuresStop for ${retailChain}?`}
                    axiosFunction={makeApiCallPost}
                    url={`${process.env.REACT_APP_EDP_API_BASE_URL}/deleteConfigsForRetailer`}
                    postBody={{
                        user: getUserEmail(),
                        retailerId: retailerId
                    }}
                    toastTextFailure={`Failed to delete configurations for ${retailChain}.`}
                    toastTextSuccess={`Deleted configurations for ${retailChain}. See Audit Tab for further details.`}
                />
            </Page>
        </div>
    </>);
};

ActionsTab.propTypes = {
    active: PropTypes.bool.isRequired,
    retailChain: PropTypes.string.isRequired,
    retailerId: PropTypes.number.isRequired
};

